import { apiQuery } from "utils/queries";
import { api } from "./restUtil";

type TranslationResponse = {
  input: string;
  translated_text: string;
};

export type TranslationQueryParams = {
  text: string;
  source_lang?: string;
  target_lang: string;
};

export const translatedTextQuery = apiQuery<TranslationResponse, TranslationQueryParams>({
  key: "/google/translation",
  // Paid Google call: a failed translation must not be retried automatically.
  retry: false,
});

// Imperative counterpart of the query, for button-triggered translation.
export function fetchTranslation(params: TranslationQueryParams) {
  return api.get<TranslationResponse, TranslationQueryParams>(
    "/google/translation",
    params
  );
}

export const MAX_TRANSLATION_LENGTH = 5000;
